import { render, staticRenderFns } from "./TheBrain.vue?vue&type=template&id=1b04cc8c&lang=pug&"
import script from "./TheBrain.vue?vue&type=script&lang=js&"
export * from "./TheBrain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports